export default __webpack_public_path__ + "static/media/selectTriangleBW.b8c13999.svg";